import { Tooltip } from "bootstrap";
import uiStore from "../common/stores/uiStore.js";
import { EVENTS, storeEvents } from "../common/stores/storeEvents.js";
import rootPersonStore from "../common/stores/rootPersonStore.js";
import authStore from "../common/stores/authStore.js";
// protectedFeatures.js deleted — the downloadPdf flow it served was dead code.
import { loadGedcomFile } from "../gedcom/gedcomFileHandler.js";
import { initializeDownloadButton } from "./downloadButton.js";
import contextStore from "../common/stores/contextStore.js";
import { logger } from "../utils/debug/logger.js";
import gedcomDataStore from "../gedcom/stores/gedcomDataStore.js";
import gedcomDropdownManager from "../gedcom/gedcomDropdownManager.js";
// Import du store centralisé des onglets
import { tabStateStore } from "../common/stores/tabStateStore.js";
// personDetailsManager import removed - not used

logger.ui.debug('📋 uiStore initialized in eventListeners:', uiStore);
logger.ui.debug('📊 tabStateStore initialized in eventListeners:', tabStateStore);
// WeakMap to store event listener references
const eventListenersMap = new WeakMap();

// Setup tooltips with HTML support
export function setupTooltips() {
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  tooltipTriggerList.forEach((tooltipTriggerEl) => {
    new Tooltip(tooltipTriggerEl, { html: true });
  });
}

// PersonDetailsManager is now initialized and ready to handle global person details
// All person details events are now handled by PersonDetailsManager (bottom drawer only)
// Usage: personDetailsManager.show(personId) or PersonDetailsManager.emitShowPersonDetails(personId)

// Handle city link clicks with delegation
/*
function handleCityLinkClick(event) {
    if (event.target.classList.contains("city-link")) {
        const townKey = event.target.dataset.townKey;
        const townDetails = familyTownsStore.getTown(townKey);
        const latitude = parseFloat(townDetails.latitude);
        const longitude = parseFloat(townDetails.longitude);

        if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
            const marker = googleMapsStore.allMarkers[townKey];
            if (marker) {
                googleMapsStore.map.setCenter(
                    new google.maps.LatLng(latitude, longitude)
                );
                googleMapsStore.map.setZoom(10);
                if (!marker.infowindow) {
                    marker.infowindow = new google.maps.InfoWindow({
                        content: marker.getTitle(),
                    });
                }
                marker.infowindow.open(googleMapsStore.map, marker);
            } else {
                console.error("No marker found for this town key:", townKey);
            }
        } else {
            console.error("Invalid latitude or longitude values", townDetails);
        }
    }
}
    */

// Close popover on outside click - Commented out as it's not currently used
// function closePopoverOnClickOutside(event) {
//   const popover = document.getElementById("customPopover");
//   if (popover && !popover.contains(event.target)) {
//     popover.style.display = "none";
//   }
// }

// ✅ SUPPRIMÉ: setupPersonLinkEventListener() - Redondant avec PersonDetailsManager
// PersonDetailsManager gère maintenant tous les clics sur .person-link de manière centralisée
// avec support de data-show-details pour afficher le bottom drawer OU changer la root

// Update UI after undo/redo actions
function updateUIAfterUndoRedo() {
  const root = rootPersonStore.root; // Utiliser rootPersonStore
  if (root) {
    const tomSelect = rootPersonStore.tomSelect; // Utiliser rootPersonStore
    if (tomSelect) {
      rootPersonStore.setTomSelectValue(root);
    } else {
      logger.ui.error("tomSelect is undefined");
    }
  }
}

// Setup undo/redo event listeners
function setupUndoRedoEventListeners() {
  const undoHandler = () => {
    rootPersonStore.undo(); // Utiliser rootPersonStore
    updateUIAfterUndoRedo();
  };
  const redoHandler = () => {
    rootPersonStore.redo(); // Utiliser rootPersonStore
    updateUIAfterUndoRedo();
  };
  const keydownHandler = (event) => {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "z") {
      event.preventDefault();
      undoHandler();
    }
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "y") {
      event.preventDefault();
      redoHandler();
    }
  };

  document.getElementById("undoButton").addEventListener("click", undoHandler);
  document.getElementById("redoButton").addEventListener("click", redoHandler);
  document.addEventListener("keydown", keydownHandler);

  // Store references in WeakMap
  eventListenersMap.set(document.getElementById("undoButton"), undoHandler);
  eventListenersMap.set(document.getElementById("redoButton"), redoHandler);
  eventListenersMap.set(document, keydownHandler);
}

// Function to initialize file loading event listeners
const setupFileLoadingEventListeners = () => {
  // Demo file loading — sample isn't tied to files-service, so clear
  // currentFileId. This disables tab7 (Photos) since the user has no
  // anchored GEDCOM in their account.
  Array.from(document.getElementsByClassName("remote-file")).forEach(function (
    element
  ) {
    element.addEventListener("click", async function (e) {
      const configStore = (await import("../tabs/fanChart/fanConfigStore.js")).default;
      configStore.setCurrentFileId(null);
      loadGedcomFile(e.target.getAttribute("data-link"));
      return false;
    });
  });

  // User file loading - input file change event. currentFileId is cleared
  // until upload completes (uploadProcessedCacheToFilesService re-sets it
  // with the new files-service id once persistence is done).
  document.getElementById("file").addEventListener("change", async function (e) {
    const configStore = (await import("../tabs/fanChart/fanConfigStore.js")).default;
    configStore.setCurrentFileId(null);
    loadGedcomFile(e.target.files);
  });
  
  // User file loading - gedcomFileInput div click event to trigger file input
  const gedcomFileInputDiv = document.getElementById("gedcomFileInput");
  const fileInput = document.getElementById("file");
  
  if (gedcomFileInputDiv && fileInput) {
    let isProcessing = false; // Prevent infinite loop
    
    gedcomFileInputDiv.addEventListener("click", function(e) {
      if (isProcessing) return;
      
      isProcessing = true;
      e.preventDefault();
      e.stopPropagation();
      
      fileInput.click();
      
      // Reset flag after a short delay
      setTimeout(() => {
        isProcessing = false;
      }, 1000);
    });
  }
  
  // Handle hero section import button - add event listener as fallback
  setTimeout(() => {
    const heroImportButton = document.getElementById("heroImportButton");
    const fileInput = document.getElementById("file");
    
    if (heroImportButton && fileInput) {
      // Add a click event listener as backup to the onclick
      heroImportButton.addEventListener("click", function() {
        // Only act if the onclick didn't work
        setTimeout(() => {
          if (fileInput && !fileInput.disabled) {
            fileInput.click();
          }
        }, 10);
      });
    }
  }, 100); // Small delay to ensure both elements exist
};

// Fonction pour gérer le bouton de menu d'import
function setupUserMenuToggle() {
  const toggle = document.getElementById("user-menu-toggle");
  const popover = document.getElementById("user-menu-popover");
  if (!toggle || !popover) return;

  // Positioning shim: the Popover API gives us visibility, dismissal
  // (click-outside + ESC) and top-layer rendering for free, but it
  // doesn't anchor the popover to the toggler. CSS Anchor Positioning
  // would, but isn't in Firefox yet — so we read the toggler's rect on
  // each open and pin the popover under it, aligned to its right edge.
  const place = () => {
    const r = toggle.getBoundingClientRect();
    popover.style.top = `${r.bottom + 4}px`;
    popover.style.right = `${window.innerWidth - r.right}px`;
  };

  popover.addEventListener("beforetoggle", (e) => {
    if (e.newState === "open") place();
  });

  // Keep aria-expanded in sync with popover state so screen readers
  // and our CSS hover/state rules behave correctly.
  popover.addEventListener("toggle", (e) => {
    toggle.setAttribute("aria-expanded", e.newState === "open" ? "true" : "false");
  });

  // Re-place on viewport resize while open (rare but cheap).
  window.addEventListener("resize", () => {
    if (popover.matches(":popover-open")) place();
  });

  // Native popovers stay open when a child is clicked; menu items
  // need to close on activation.
  popover.addEventListener("click", (e) => {
    if (e.target.closest(".dropdown-item")) popover.hidePopover();
  });
}

// Setup tab and UI event listeners
function setupTabAndUIEventListeners() {
  document.querySelectorAll(".dropdown-menu a").forEach((element) => {
    element.addEventListener("click", function (event) {
      // Skip GEDCOM dropdown (managed by data-bs-auto-close="outside")
      // and any popover-based menu (handled by hidePopover in its own setup).
      const dropdownMenu = this.closest(".dropdown-menu");
      if (dropdownMenu && dropdownMenu.id === 'gedcomDropdownMenu') return;
      if (dropdownMenu && dropdownMenu.hasAttribute('popover')) return;

      logger.ui.debug("Clicked element:", event.target);
      const dropdownButton = this.closest(".dropdown");
      if (!dropdownButton) return;
      dropdownButton.classList.remove("show");
      dropdownButton.querySelector(".dropdown-menu")?.classList.remove("show");
    });
  });

  document.getElementById('sign-in-button')?.addEventListener('click', (e) => {
    e.preventDefault();
    // No-op when the item is disabled (e.g. iframe mode where the parent owns auth).
    if (e.currentTarget.classList.contains('disabled')) return;
    // Utiliser le contextStore pour adapter le comportement selon le contexte

    // Guests authenticated via auth-service (__authsvc cookie) own their
    // session client-side — clicking the user icon logs them out by hitting
    // auth.genealogie.app/logout, which clears the cookie and bounces them
    // back to /guest/. The 403 page there now exposes a passkey re-login
    // CTA, so this stays a one-tap path back in.
    if (authStore.authMode === 'guest' && authStore.isAuthenticated) {
      const next = encodeURIComponent('https://genealogie.app/guest/');
      window.location.href = `https://auth.genealogie.app/logout?next=${next}`;
      return;
    }

    if (contextStore.isInIframe) {
      // En mode iframe, informer le site parent qu'on souhaite accéder à une fonctionnalité d'authentification
      window.parent.postMessage({
        action: 'authenticationRequest',
        currentStatus: authStore.isAuthenticated ? 'authenticated' : 'unauthenticated'
      }, '*');

      // Informer l'utilisateur
      if (authStore.isAuthenticated) {
        window.alert(`✅ Connecté via le site parent en tant que ${authStore.userInfo.email}`);
      } else {
        window.alert('L\'authentification est gérée par le site dans lequel GeneaFan est intégré.');
      }
    } else if (!authStore.isAuthenticated) {
      // En mode direct ou proxy, utiliser la méthode normale
      authStore.showSignInForm();
    } else {
      // Déjà authentifié
      window.alert(`✅ Connecté en tant que ${authStore.userInfo.email}`);
    }
  });
  
  // Gestion du bouton Home pour le retour à la page d'accueil
  document.getElementById('home-button')?.addEventListener('click', (e) => {
    e.preventDefault();
    // Utiliser le contextStore pour connaître le mode d'exécution

    if (contextStore.isInIframe) {
      // Dans un iframe, informer le parent qu'on souhaite retourner à l'accueil
      logger.ui.debug('📣 Envoi du message returnToHome au site parent');
      try {
        window.parent.postMessage({ 
          action: 'returnToHome',
          source: 'geneafan'
        }, '*');
        logger.ui.debug('✅ Message envoyé au parent');
      } catch (error) {
        logger.ui.error('❌ Erreur lors de l\'envoi du message au parent:', error);
      }
    } else if (contextStore.isProxied) {
      // Sur un proxy, "Retour à l'accueil" = retour vers le site partenaire (loginUrl).
      // Pour les partenaires custom hostname : loginUrl injecté par le gateway via cookie.
      // Fallback transitoire (familystory.live legacy avant migration) : racine du domaine courant.
      window.location.href = contextStore.loginUrl || contextStore.origin || '/';
    } else {
      // Application autonome : pas de partenaire connu. Fallback historique vers familystory.live
      // (sera retiré après la migration complète vers le mode custom hostname).
      window.location.href = contextStore.loginUrl || 'https://familystory.live/';
    }
  });

  // Gestion du bouton "Activer les alertes" dans le menu d'aide
  document.getElementById('activateAlerts')?.addEventListener('click', (e) => {
    e.preventDefault();
    
    // Supprimer les clés localStorage pour réactiver les alertes
    localStorage.removeItem('geneafan_privacy_dismissed');
    localStorage.removeItem('geneafan_welcome_dismissed');
    
    logger.ui.debug('✓ Alertes réactivées - rechargement de la page');
    
    // Recharger la page pour afficher les alertes
    window.location.reload();
  });

  // Les onglets responsives sont maintenant gérés automatiquement par tabStateStore

  setupUserMenuToggle();

  setupTooltips();
}

let eventListenersInitialized = false;

export const setupAllEventListeners = (authStore) => {
  if (eventListenersInitialized) {
    return;
  }

  eventListenersInitialized = true;

  const initializeEventListeners = () => {
    logger.ui.group("EventListeners: Initializing..."); // Debug

    // Configuration des écouteurs globaux
    setupTabAndUIEventListeners(); // Cette fonction appelle maintenant setupFileMenu()
    setupFileLoadingEventListeners();
    setupUndoRedoEventListeners();
    // Nous n'avons plus besoin d'appeler setupAutoOpenGedcomMenu() ici

    // Initialize GEDCOM dropdown manager (file list in dropdown)
    gedcomDropdownManager.initialize();

    // Initialiser le bouton de téléchargement paresseux
    initializeDownloadButton();

    // Bouton "Exporter ascendance" dans le header (à côté undo/redo)
    import('../common/exportForPersonButton.js').then(({ initializeExportForPersonButton }) => {
      initializeExportForPersonButton();
    }).catch(err => logger.ui.error('exportForPersonButton init failed:', err));

    // Émettre l'événement de chargement initial immédiatement
    logger.ui.debug("EventListeners: Emitting APP_LOADED"); // Debug
    storeEvents.emit(EVENTS.ONBOARDING.APP_LOADED);

    // Émettre l'événement lors du chargement d'un GEDCOM
    document.addEventListener("gedcomLoaded", () => {
      logger.ui.debug("EventListeners: GEDCOM loaded, emitting GEDCOM_UPLOADED"); // Debug
      storeEvents.emit(EVENTS.ONBOARDING.GEDCOM_UPLOADED);
    });

    // Émettre l'événement lors du changement d'onglet
    document.querySelectorAll(".nav-link").forEach((tab) => {
      tab.addEventListener("shown.bs.tab", (e) => {
        const tabId = e.target.getAttribute("href").substring(1);
        logger.ui.debug("EventListeners: Tab opened:", tabId); // Debug
        storeEvents.emit(EVENTS.ONBOARDING.TAB_OPENED, tabId);
      });
    });

    logger.ui.debug("✅ Event listeners initialized");
    logger.ui.groupEnd();
  };

  // Si le document est déjà chargé, initialiser immédiatement
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeEventListeners);
  } else {
    initializeEventListeners();
  }
};

/**
 * Fonction globale pour gérer l'expansion/réduction des détails d'événements
 * Appelée par les boutons "Lire plus" dans les descriptions d'événements
 * @param {HTMLElement} button - Le bouton cliqué
 */
window.toggleEventDetails = function(button) {
    const noteId = button.dataset.noteId;
    const extraDetails = button.dataset.extraDetails;
    
    // Vérifier si les détails sont déjà affichés (chercher dans le sibling suivant)
    const existingDetails = button.parentElement.nextElementSibling?.classList.contains('event-details-expanded') 
        ? button.parentElement.nextElementSibling 
        : null;
    
    if (existingDetails) {
        // Réduire : supprimer les détails et changer le texte du bouton
        existingDetails.remove();
        button.innerHTML = '📝 Lire plus';
    } else {
        // Étendre : afficher les détails
        expandEventDetails(button, noteId, extraDetails);
    }
};

/**
 * Affiche les détails étendus d'un événement
 * @param {HTMLElement} button - Le bouton "Lire plus"
 * @param {string} noteId - ID de la note à récupérer
 * @param {string} extraDetails - Détails supplémentaires à afficher
 */
async function expandEventDetails(button, noteId, extraDetails) {
    const detailsContainer = document.createElement('div');
    detailsContainer.className = 'event-details-expanded mt-2 p-3 bg-light border-start border-3 border-primary';
    
    let content = '';
    
    // Ajouter les détails supplémentaires si présents
    if (extraDetails && extraDetails !== 'undefined' && extraDetails.trim() !== '') {
        content += `<div class="extra-details mb-2">
                        <small class="text-muted">Détails :</small><br>
                        <span class="fw-bold">${extraDetails}</span>
                    </div>`;
    }
    
    // Récupérer et afficher la note si présente
    if (noteId && noteId !== 'undefined' && noteId.trim() !== '') {
        try {
            // Accéder au cache des notes via le getter propre de gedcomDataStore
            const notesCache = gedcomDataStore.notesCache;
            console.log('🔍 Debug notesCache via getter:', notesCache);
            
            if (notesCache && notesCache.get) {
                const noteData = notesCache.get(noteId);
                console.log(`🔍 Note récupérée pour ${noteId}:`, noteData);
                if (noteData && noteData.text && noteData.text.trim() !== '') {
                    // Convertir les sauts de ligne en <br> pour l'affichage HTML
                    const formattedText = noteData.text.replace(/\n/g, '<br>');
                    content += `<div class="note-content">
                                    <small class="text-muted">Note :</small><br>
                                    <div class="fst-italic">${formattedText}</div>
                                </div>`;
                }
            } else {
                console.warn('notesCache non disponible via gedcomDataStore.notesCache');
            }
        } catch (error) {
            console.warn('Erreur lors de la récupération de la note:', noteId, error);
        }
    }
    
    // Si aucun contenu trouvé, afficher un message
    if (!content) {
        content = '<small class="text-muted fst-italic">Aucun détail supplémentaire disponible.</small>';
    }
    
    detailsContainer.innerHTML = content;
    
    // Insérer les détails après le paragraphe contenant le bouton
    button.parentElement.insertAdjacentElement('afterend', detailsContainer);
    
    // Changer le texte du bouton
    button.innerHTML = '📁 Réduire';
}
